
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 22 22","fill":"none","xmlns":"http://www.w3.org/2000/svg","data-token-name":"coins"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.984 12.667H6.207a1.19 1.19 0 00-.445 2.302l1.831.73A1.191 1.191 0 017.15 18H5.371m1.28-5.333V12m0 6.667V18m8.571-5.444a5.777 5.777 0 10-5.778-5.778m7.174 3a2.889 2.889 0 010-5.778M13 6.889h3.618m-4.062 8.333a5.778 5.778 0 11-11.556 0 5.778 5.778 0 0111.556 0z","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    